module.exports = __webpack_public_path__ + "static/media/MultipleChoice.a2486fce.svg";